/**
 * Merges the fetch-service level `Authorization` header into the caller's headers.
 * A header set explicitly by the caller always wins.
 */
export const withAuthorization = (
    headers: HeadersInit | undefined,
    authorization: (() => string | undefined) | undefined
): HeadersInit | undefined => {
    const authorizationValue = authorization?.()

    if (!authorizationValue) return headers

    const merged = new Headers(headers)

    if (!merged.has("Authorization")) {
        merged.set("Authorization", authorizationValue)
    }

    return merged
}
